import React from 'react';
import * as FiIcons from 'react-icons/fi';

const SafeIcon = ({ icon: Icon, name, className, ...props }) => {
  if (Icon) {
    return <Icon className={className} {...props} />;
  }
  
  if (name && FiIcons[`Fi${name}`]) {
    const FallbackIcon = FiIcons[`Fi${name}`];
    return <FallbackIcon className={className} {...props} />;
  }

  const Alert = FiIcons.FiAlertCircle;
  return <Alert className={className} {...props} />;
};

export default SafeIcon;